import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'edit-path';
export function useSendEditPath() {
    const { postMessage } = useIframeMessageContext();
    const sendEditPath = useCallback((path) => {
        postMessage(MESSAGE_TYPE, path);
    }, [postMessage]);
    return { sendEditPath };
}
const handleMessage = (context, message) => {
    if (message.body) {
        const { setEditPath } = context;
        setEditPath(message.body, { shouldSendIframe: false });
    }
};
registerIframeMessageHook(MESSAGE_TYPE, useSendEditPath, handleMessage);
//# sourceMappingURL=useSendEditPath.js.map